import FontFaceObserver from "fontfaceobserver";

const TIMEOUT = 300000; // 5 minutes

/**
 * Send a timing event to Google Tag Manager
 * It'll then appears under Google Analytics > User Timing
 *
 * @param eventName : name of the event to send
 */
let sendLoadTime = function(eventName) {
    if(performance && performance.now) {
        const now = Math.round(performance.now());
        if (now > TIMEOUT) // If event was triggered after timeout value, we discard it because it's probably a wrong value
            return;

        //console.log(`[Analytics] Trigger ${eventName} after ${now}ms`);

        if (performance.mark) { // performance.mark can be unsupported by some browsers
            performance.mark(eventName);
        }

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'UniversalTimingEvent',
            timeEventCategory: eventName,
            timeEventAction: eventName,
            timeEventValue: now
        });
    }
};

// Measure main fonts loading time
new FontFaceObserver('Fira Sans Extra Condensed', { weight: 700 })
    .load(null, TIMEOUT)
    .then( () => sendLoadTime("mainFontLoaded") )
    .catch( () => console.warn("[Analytics] Main font couldn't be loaded (timeout)"));

export default {
    sendLoadTime: sendLoadTime
};



// WEBPACK FOOTER //
// ./js/analytics/analytics.js